import gql from 'graphql-tag';

const GOOGLE_ANALYTICS_ACCESSIBLE_PROPERTIES = gql`
  query googleAnalyticsAccessibleProperties($orgId: String!) {
    googleAnalyticsAccessibleProperties(orgId: $orgId)
  }
`;

export default GOOGLE_ANALYTICS_ACCESSIBLE_PROPERTIES;
